import { resetUserId, setUserId } from '../../../State/Auth/AuthActions'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'src/State/RootReducer'

interface UseUserId {
  updateUserId: (userId: number) => void
  removeUserId: () => void

  getUserId: () => number | undefined
}

/**
 * Hook that returns user id and functions to update and remove it from the store
 */
const useUserId = (): UseUserId => {
  const dispatch = useDispatch()
  const userId = useTypedSelector(state => state.auth.userId)

  const updateUserId = (userId: number): void => {
    dispatch(setUserId(userId))
  }

  const removeUserId = (): void => {
    dispatch(resetUserId())
  }

  return { updateUserId, removeUserId, getUserId: () => userId }
}

export default useUserId
